import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaFileInvoice, FaMapMarkerAlt, FaEye,
    FaUserTie, FaCalendarDay, FaExclamationCircle, FaBox
} from "react-icons/fa";

export default function ViolationPage() {
    const location = useLocation();
    const { backEnd_request } = BackMethods();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [reports, setReports] = useState([]);

    const query = new URLSearchParams(location.search);

    // وظيفة لقص النص إلى أول 10 كلمات
    const truncateWords = (text, limit) => {
        if (!text) return "---";
        const words = text.split(" ");
        if (words.length > limit) {
            return words.slice(0, limit).join(" ") + "...";
        }
        return text;
    };

    // داخل useEffect في ViolationPage.js
    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                let data = [];

                // استخراج القيم من الرابط
                const establishment = query.get("establishment");
                const violationTypeId = query.get("violationTypeId"); // المفتاح الصحيح
                const reportNumber = query.get("reportNumber");
                const inspector = query.get("inspector");

                if (establishment) {
                    data = await backEnd_request.get(`/ViolationReports/by-establishment/${establishment}`).then(r => r.data);
                    console.log(data);
                    setReports(data);
                }
                else if (violationTypeId) {
                    // تعديل الرابط ليكون ?violationTypeId=16 كما طلبت
                    data = await backEnd_request.get(`/ViolationReports/by-type?violationTypeId=${violationTypeId}`).then(r => r.data);
                    setReports(data.data);
                }
                else if (reportNumber) {
                    data = await backEnd_request.get(`/ViolationReports/by-report-number?number=${reportNumber}`).then(r => r.data);
                    setReports(data);
                }
                else if (inspector) {
                    // تعديل الرابط ليتناسب مع الـ API المطلوب: by-inspector?inspectorName=الاسم
                    data = await backEnd_request.get(`/ViolationReports/by-inspector?inspectorName=${inspector}`).then(r => r.data);
                    setReports(data);
                }
                // console.log(data)

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [location.search]);

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            <div className="container-fluid px-4">

                <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded-3 shadow-sm">
                    <div>
                        <h4 className="fw-bold text-dark m-0"><FaFileInvoice className="ms-2 text-primary" /> سجل الضبوط المنظمة</h4>
                        <small className="text-muted">إجمالي السجلات: {reports.length}</small>
                    </div>
                    <button onClick={() => navigate(-1)} className="btn btn-dark btn-sm rounded-pill px-4 shadow-sm">رجوع</button>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                ) : (
                    <div className="table-responsive custom-table-container">
                        <table className="table table-hover align-middle main-modern-table">
                            <thead>
                                <tr>
                                    <th>معلومات الضبط</th>
                                    <th>نوع المخالفة</th>
                                    <th>المخالف</th>
                                    <th>المحجوزات</th>
                                    <th>الموقع</th>
                                    <th>التاريخ والوقت</th>
                                    <th className="text-center">عرض</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reports.map((r) => (
                                    <tr key={r.violationReportId} className="table-row-item">
                                        {/* رقم الضبط بدون # */}
                                        <td>
                                            <div className="fw-bold text-primary fs-6">رقم الضبط: {r.reportNumber}</div>
                                            <div className="x-small text-muted">قضية: {r.caseNumber || '---'}</div>
                                        </td>

                                        {/* نوع المخالفة مع تحديد عدد الكلمات */}
                                        <td style={{ maxWidth: '250px' }}>
                                            <div className="d-flex align-items-start gap-2">
                                                <FaExclamationCircle className="text-warning mt-1" />
                                                <div>
                                                    <div className="fw-bold small">{r.violationType?.name || "غير محدد"}</div>
                                                    <div className="x-small text-muted">
                                                        {truncateWords(r.violationSummary, 10)}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <div className="fw-bold small">{r.offenderName}</div>
                                            <span className="badge bg-soft-dark text-dark border fw-normal x-small">{r.offenderRole}</span>
                                        </td>

                                        <td>
                                            <div className="small"><FaBox className="ms-1 text-secondary" /> {r.seizedQuantity || 0}</div>
                                            <div className="x-small text-muted">{r.depositDestination || '---'}</div>
                                        </td>

                                        <td>
                                            <div className="small fw-bold">{r.governorate}</div>
                                            <div className="x-small text-muted">{r.city} - {r.district}</div>
                                        </td>

                                        <td>
                                            <div className="small fw-bold text-dark"><FaCalendarDay className="ms-1 text-info" />{r.reportDate?.split("T")[0]}</div>
                                            <div className="x-small text-muted">{r.reportTime?.slice(0, 5)} | {r.dayName}</div>
                                        </td>

                                        <td className="text-center">
                                            <button
                                                className="action-btn view mx-auto"
                                                title="عرض التفاصيل"
                                                onClick={() => navigate(`/admin/violation-details?id=${r.reportNumber}`)}
                                            >
                                                <FaEye />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {reports.length === 0 && (
                            <div className="text-center py-5 bg-white rounded-3 shadow-sm mt-3 text-muted">لا توجد سجلات حالياً</div>
                        )}
                    </div>
                )}
            </div>

            <style>{`
                .x-small { font-size: 0.72rem; }
                .bg-soft-dark { background-color: #f8f9fa; }
                .custom-table-container { background: transparent; }

                .main-modern-table { border-collapse: separate; border-spacing: 0 10px; }
                .main-modern-table thead th { border: none; color: #6c757d; font-size: 0.85rem; padding: 10px 15px; }

                .table-row-item { background-color: #fff; box-shadow: 0 3px 10px rgba(0,0,0,0.03); }
                .table-row-item td { padding: 15px; border: none; }

                .table-row-item td:first-child { border-right: 4px solid #1a1d20; border-top-right-radius: 10px; border-bottom-right-radius: 10px; }
                .table-row-item td:last-child { border-top-left-radius: 10px; border-bottom-left-radius: 10px; }

                .table-row-item:hover { 
                    background-color: #fcfcfc !important; 
                    transform: translateY(-2px);
                    transition: 0.3s ease;
                }

                .action-btn.view { 
                    width: 36px; height: 36px;
                    border-radius: 10px; border: none;
                    background: #1a1d20; color: #fff;
                    display: flex; align-items: center; justify-content: center;
                }
            `}</style>
        </div>
    );
}